import { HTTPService, JsonResultClass } from '../../core/util/httpManager';
import { SourceItem, ChatGPTResponse, PagedSearchResult } from '../semantic_search.types';
import { SearchTarget, SortOrder } from '../store/semantic_search.store.types';

export interface ISemanticSearchApiService {
    executeSearch: (searchQuery: string, page: number, pageSize: number, isFuzzy: boolean, useWildcards: boolean, searchTarget: SearchTarget, sortBy: SortOrder) => Promise<PagedSearchResult>;
    validateSources: (searchQuery: string, sources: SourceItem[]) => Promise<ChatGPTResponse>;
}

const executeSearch = async (searchQuery: string, page: number, pageSize: number, isFuzzy: boolean, useWildcards: boolean, searchTarget: SearchTarget, sortBy: SortOrder): Promise<PagedSearchResult> => {
    const response = await HTTPService.post<JsonResultClass<PagedSearchResult>>(`SemanticSearch/ExecuteSearch`, {
        searchQuery,
        page,
        pageSize,
        isFuzzy,
        useWildcards,
        searchTarget,
        sortBy,
    });
    if (response && response.Code > 0) {
        throw { Code: response.Code, Message: response.Message, AdditionalData: response.AdditionalData };
    }
    return response.Data ?? { Results: [], HasMore: false };
};

const validateSources = async (searchQuery: string, sources: SourceItem[]): Promise<ChatGPTResponse> => {
    const response = await HTTPService.noBusyIndicator().post<JsonResultClass<ChatGPTResponse>>(`Chatgpt/ValidateSources`, {
        searchRequest: { Question: searchQuery, Sources: sources.map((item, i) => ({ Id: i, SourceText: item.Title })) },
    });
    if (response && response.Code > 0) {
        throw { Code: response.Code, Message: response.Message, AdditionalData: response.AdditionalData };
    }
    return response.Data as ChatGPTResponse;
};

export const semanticSearchApiService: ISemanticSearchApiService = {
    executeSearch,
    validateSources,
};